import createReactComponent from '../createReactComponent';
var Monitor = createReactComponent('Monitor', [['rect', {
  x: '2',
  y: '3',
  width: '20',
  height: '14',
  rx: '2',
  ry: '2',
  key: '1q87ek'
}], ['line', {
  x1: '8',
  y1: '21',
  x2: '16',
  y2: '21',
  key: 'bcbiac'
}], ['line', {
  x1: '12',
  y1: '17',
  x2: '12',
  y2: '21',
  key: '1v4d7v'
}]]);
export default Monitor;